import React from "react";
import {
  deriveLtaStatus,
  getStatusMeta,
  daysRemaining,
  isExpiringSoon,
} from "./ltaOptions";

/**
 * The agreement's status, worked out from its term rather than read off the
 * record, optionally annotated with how close it is to lapsing. The countdown
 * only appears while the agreement is still running.
 */
const LTAStatusBadge = ({
  startDate,
  endDate,
  showCountdown,
}: {
  startDate?: string | null;
  endDate?: string | null;
  showCountdown?: boolean;
}) => {
  const status = deriveLtaStatus(startDate, endDate);
  const meta = getStatusMeta(status);
  const days = daysRemaining(endDate);
  const expiring = status === "ACTIVE" && isExpiringSoon(endDate);

  return (
    <div className="d-flex align-items-center gap-1 flex-wrap">
      <span
        className={`badge bg-${
          meta?.color || "warning"
        }-subtle text-${meta?.color || "warning"} fs-11`}
      >
        {meta?.label || "Not Provided"}
      </span>

      {showCountdown && expiring && (
        <span className="badge bg-warning-subtle text-warning fs-11">
          <i className="ri-timer-line align-bottom me-1"></i>
          {days === 0 ? "Ends today" : `${days}d left`}
        </span>
      )}
    </div>
  );
};

export default LTAStatusBadge;
